import axios from "axios";

export interface UpdateVipConfigurationDTO {
  communityId: string;
  enabled?: boolean;
  price?: number;
  fee?: number;
  stripeAccountId?: string;
}

export async function updateVipConfiguration(
  vipConfiguration: UpdateVipConfigurationDTO,
) {
  const baseApiUrl = process.env.REACT_APP_BASE_API_URL;

  const response = await axios.put(
    `${baseApiUrl}/payment/v0/admin/vip-configuration`,
    vipConfiguration,
    {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("accessToken"),
      },
    },
  );

  return response.data;
}
